import { Button } from 'antd';
import { ButtonType } from 'antd/lib/button';
import React from 'react';

import './style.scss';

interface IProps {
    type?: ButtonType;
    htmlType?: 'button' | 'submit' | 'reset';
    text?: React.ReactNode;
    icon?: React.ReactNode;
    iconRight?: React.ReactNode;
    className?: string;
    color?: string;
    disabled?: boolean;
    width?: string | number;
    height?: string | number;
    isLoading?: boolean;
    onClick?: () => void;
    letterSpacing?: boolean;
    danger?: boolean;
    warning?: boolean;
    children?: React.ReactNode;
    borderRadius?: string;
    columnGap?: number;
}

const ButtonWrap: React.FC<IProps> = ({
    type = 'default',
    htmlType = 'button',
    text,
    icon,
    className = '',
    color,
    disabled,
    width,
    height,
    isLoading,
    onClick,
    letterSpacing,
    danger,
    iconRight,
    children,
    borderRadius,
    columnGap = 8,
}) => {
    return (
        <Button
            type={type}
            danger={danger}
            className={`c-button ${className} ${type}`}
            color={color}
            style={{
                width: width,
                height: height,
                letterSpacing: letterSpacing ? '-2px' : 'unset',
                borderRadius: borderRadius,
                columnGap: columnGap,
            }}
            icon={icon}
            onClick={onClick}
            disabled={disabled}
            loading={isLoading}
            htmlType={htmlType}
        >
            {text}
            {iconRight}
            {children}
        </Button>
    );
};

export default React.memo(ButtonWrap);
